export interface UnloadedFuelDataResolved {
    id: number,
    resolved: boolean
}
